import ZkUserDetail from './src/main'
ZkUserDetail.install = function (Vue) {
  Vue.component(ZkUserDetail.name, ZkUserDetail)
}
export default ZkUserDetail



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/userDetail/index.js